import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./CustomAlertBox.css";

const CustomAlertBox = ({ open, onClose, message }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate("/ahpra-validation-tool/dashboard/individual-search"); 
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <Box className="alert-box-container">

        <DialogTitle
          className="alert-box-header"
          sx={{
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: "bold",
            color: "white",
            backgroundColor: "#FF6F61",
          }}
        >
          Validation Not Allowed
        </DialogTitle>

        <DialogContent
          className="alert-box-content"
          sx={{ textAlign: "center", padding: "1.5rem" }}
        >
          <Typography
            variant="body1"
            sx={{ fontSize: "1.2rem", fontWeight: "500", color: "#333" }}
          >
            {message}
          </Typography>
        </DialogContent>

        <DialogActions
          className="alert-box-footer"
          sx={{
            padding: "1rem",
            justifyContent: "center",
            backgroundColor: "#f5f5f5",
          }}
        >
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              backgroundColor: "#2E3B55",
              color: "#fff",
              "&:hover": { backgroundColor: "#1d2a3f" },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default CustomAlertBox;
